module.exports = __webpack_public_path__ + "img/ar_btn_sec_g.bc013a4f.svg";